import { Alert, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { en } from '../translations/en';

interface NewVersionBannerProps {
  visible: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
}

export function NewVersionBanner({ visible, onRefresh, onDismiss }: NewVersionBannerProps) {
  if (!visible) {
    return null;
  }

  return (
    <Alert
      severity="info"
      variant="filled"
      sx={{ position: 'sticky', top: 0, zIndex: 1200, borderRadius: 0 }}
      action={
        <>
          <Button color="inherit" size="small" onClick={onRefresh}>
            {en.versionCheck.updateButton}
          </Button>
          <IconButton
            aria-label={en.versionCheck.dismissLabel}
            color="inherit"
            size="small"
            onClick={onDismiss}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </>
      }
    >
      {en.versionCheck.newVersionMessage}
    </Alert>
  );
}
